<template>
  <el-header class="header">
    <div class="header__logo">
      <img src="/img/logo-small.svg" alt="" />
    </div>
    <el-switch
      v-if="isLanguageSwitchAvailable"
      v-model="language"
      class="switch-language"
      active-text="EN"
      inactive-text="DE"
      style="margin-left: 15px"
    />
    <div class="header__info"></div>
    <div class="header__info-name body-1">
      {{ storeAuth.user.first_name }} {{ storeAuth.user.last_name }}
    </div>
  </el-header>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import i18n from '@/lang/index.js'
import { useAuthStore } from '@/store/auth'

const storeAuth = useAuthStore()

const isLanguageSwitchAvailable = computed(() => {
  return import.meta.env.VITE_LANGUAGE_SWITCH_AVAILABLE
})

const language = ref(localStorage.getItem('language') === 'en' ? true : false)

watch(language, () => {
  if (isLanguageSwitchAvailable.value) {
    i18n.global.locale = language.value ? 'en' : 'de'
    localStorage.setItem('language', i18n.global.locale)
  }
})
</script>
